import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackSendMessageClick } from './tracking';
import { openNewbuildingChat, openNewbuildingChatAfterAuth } from 'shared/actions/chat';
import { getNewbuildingInformation } from 'shared/selectors/newbuildingHeader';
import { getUser } from 'shared/selectors/user';
import { INewbuilding } from 'shared/types/newbuildingHeader';
import { callAuthenticationPopup } from 'shared/utils/authentication';

import type { TContactParam } from '@cian/newbuilding-chat-component';

type TUseBuilderChatOpenHandlerParams = {
  placeType: string;
};

export function useBuilderChatOpenHandler({ placeType }: TUseBuilderChatOpenHandlerParams) {
  const dispatch = useDispatch();

  const user = useSelector(getUser);
  const newbuilding = useSelector(getNewbuildingInformation) as INewbuilding;

  return React.useCallback(
    (newbuildingContact: TContactParam) => {
      trackSendMessageClick(newbuilding.id ?? 0, placeType);

      if (!user.isAuthenticated) {
        dispatch(openNewbuildingChatAfterAuth({ newbuildingContact, placeType }));
        callAuthenticationPopup();

        return;
      }

      dispatch(openNewbuildingChat({ newbuildingContact, placeType }));
    },
    [dispatch, placeType, user, newbuilding],
  );
}
